
import { ReactNode } from "react";
import style from "./Dialog.module.css";
import iconXmark from "./icons/xmark.svg";

function Dialog(props: {
    title: string;
    closable: boolean;
    style?: {
        [key: string]: any;
    };
    contentStyle?: {
        [key: string]: any;
    };
    onClose?: () => void;
    children?: ReactNode;
}) {
    return (
        <div style={{ "borderRadius": "0.25em", "overflow": "hidden", ...props.style }}>
            <div style={{ "backgroundImage": "linear-gradient(#99CCFF, #6699FF)", "height": "2.5em", "lineHeight": "2.5em", "position": "relative", "fontWeight": "normal", "margin": "0", "paddingLeft": "1em" }}>
                {props.title}
                {
                    props.closable && (
                        <span className={style["btn-close"]} onClick={() => {
                            props.onClose && props.onClose();
                        }} style={{ "position": "absolute", "top": "0", "right": "0", "width": "2em", "height": "2em", "textAlign": "center", "cursor": "pointer" }}>
                            <img src={iconXmark} alt="" style={{ height: "1em", verticalAlign: "middle", cursor: "pointer" }} />
                        </span>
                    )
                }
            </div>
            <div style={{
                "backgroundColor": "#FFF",
                ...props.contentStyle
            }}>
                {props.children}
            </div>
        </div >
    );
}
export default Dialog;